import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo, useState } from 'react';
import { StepperComponent } from 'shared/components/dialogs/router/stepper';
import { stepsSpec } from 'entities/device.add/model/steps';
import { ColumnBox } from 'shared/components/containers';
import { AddDeviceStep } from 'entities/device.add/model/type';
import { isMobileApp } from 'utils';
import { useNavigateRoot } from 'shared/hooks/router';
import { RouterDialog } from 'shared/components/dialogs/router';
export const DialogView = memo(function SimOrderCompare() {
    const [currentStep, setCurrentStep] = useState(AddDeviceStep.InputSerial);
    const [device_id, setDeviceId] = useState(null);
    const all_steps = Object.entries(stepsSpec)
        .filter(([id]) => id == AddDeviceStep.AddWiFi
        ? isMobileApp()
        : true)
        .map(([id, { title }], index) => ({
        id,
        name: title,
    }));
    const current_step_id = all_steps.findIndex(({ id }) => id == currentStep) ?? 0;
    const { title, Component } = useMemo(() => stepsSpec[currentStep], [currentStep]);
    const onFinish = useNavigateRoot();
    return (_jsxs(RouterDialog, { title: title, children: [_jsx(ColumnBox, { p: 2, alignItems: "center", children: _jsx(Component, { device_id: device_id, setNextStep: setCurrentStep, setDeviceId: setDeviceId, onFinish: onFinish }) }), _jsx(StepperComponent, { step_id: current_step_id, steps: all_steps })] }));
});
